import React from 'react';
import DSAutocomplete from '../../../design-system/DSAutocomplete';
import DSListItem from '../../../design-system/DSListItem';
import DSTextField from '../../../design-system/DSTextField';
import useStateDropdown, {
  StateDropdownProps,
} from '../hooks/useStateDropdown';
import { ReactComponent as LocationIcon } from '../../../design-system/Icons/LocationIcon.svg';
import DSBox from '../../../design-system/DSBox';

const StateDropdown = ({
  countryCode,
  initialStateCode,
  onSelect,
  disabled = false,
}: StateDropdownProps) => {
  const {
    options,
    handleInputChange,
    spacing,
    selectedState,
    handleOptionSelect,
    hasStates,
  } = useStateDropdown({ countryCode, initialStateCode, onSelect });

  const isDisabled = disabled || !countryCode || !hasStates;

  return (
    <DSAutocomplete
      options={options}
      value={selectedState}
      onChange={handleOptionSelect}
      onInputChange={handleInputChange}
      getOptionLabel={(option) => option.name}
      disabled={isDisabled}
      renderOption={(props, option) => (
        <DSListItem {...props} key={option.code}>
          {option.name}
        </DSListItem>
      )}
      renderInput={(params) => (
        <DSTextField
          {...params}
          placeholder={
            !countryCode
              ? 'Select a country first...'
              : !hasStates
                ? 'No states available'
                : 'Select a state/province...'
          }
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <DSBox
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: spacing(1),
                  marginRight: spacing(1),
                }}
              >
                <LocationIcon width="20px" height="20px" />
              </DSBox>
            ),
          }}
          sx={{
            '.MuiInputBase-root': {
              padding: 0,
            },
          }}
        />
      )}
      sx={{
        minWidth: spacing(18),
        marginLeft: spacing(3),
      }}
    />
  );
};

export default StateDropdown;
